const OnboardingStatus = [
  {
    id: 1,
    name: 'Planned',
    label: 'Planned',
  },
  {
    id: 2,
    name: 'Open',
    label: 'Open',
  },
  {
    id: 3,
    name: 'Closed',
    label: 'Closed',
  },
];

export default OnboardingStatus;
